import { Component, ViewChild } from '@angular/core';
import { SidebarComponent } from '@obo-common/shared/components/sidebar/sidebar.component';
import { ExtendedPlanning } from '@obo-dashboard/models/projectManagement.models';
import { Module } from '@obo-main/services/modules/module.models';

@Component({
    selector: 'app-configurator-detail-bar',
    templateUrl: './configurator-detail-bar.component.html',
    styleUrl: './configurator-detail-bar.component.scss',
    standalone: false
})
export class ConfiguratorDetailBarComponent {
    public selectedItem: ExtendedPlanning | Module;

    @ViewChild(SidebarComponent)
    public sidebar: SidebarComponent;
    protected isDraft = false;

    public toggleSidebar(event: ExtendedPlanning | Module, isDraft?: boolean): void {
        this.selectedItem = event;
        this.isDraft = isDraft;
        this.sidebar.toggle();
    }

    protected isPlanning(): boolean {
        return this.selectedItem instanceof ExtendedPlanning;
    }

    protected get selectedItemAsPlanning(): ExtendedPlanning {
        return this.selectedItem as ExtendedPlanning;
    }
}
